export const planKeys = {
  // System admin plans
  systemAll: ["system-plans"] as const,
  systemLists: () => [...planKeys.systemAll, "list"] as const,
  systemList: (params?: Record<string, unknown>) =>
    [...planKeys.systemLists(), params] as const,
  // Vendor billing / onboarding
  billing: ["billing"] as const,
  billingData: () => [...planKeys.billing, "data"] as const,
  currentPlan: () => [...planKeys.billing, "currentPlan"] as const,
  plans: () => [...planKeys.billing, "plans"] as const,
};
